export default __webpack_public_path__ + "static/media/black-undo-measure-icon.3564c268.svg";